<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('transference requests')"
      :columns="columns"
      :column_search="false"
      resource_url="/account-request/transference/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar -->
    <request-modal ref="request_modal" @success="refresh_datatable" />
    <view-modal ref="view_modal" @success="refresh_datatable" />
    <log-modal ref="log_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import RequestModal from "./request_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import ViewModal from "./view_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  format_date_time,
  error_message,
} from "@/utils";

export default {
  name: "AccountRequestDataTable",
  components: {
    GenericTable,
    RequestModal,
    LogModal,
    ViewModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("destinatary"),
          data: (row) =>
            `<div class="title is-6"><span class="icon"><i class="fa fa-user"></i></span>${row.destinatary.name}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span>${row.destinatary.dpi}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-envelope"></i></span>${row.destinatary.email}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-phone"></i></span>${row.destinatary.phone}</div>`,
        },
        {
          title: this.$t("entity"),
          data: (row) =>
            `<div class="title is-5"><span class="icon"><i class="fa fa-building"></i></span>${
              row.entity.name
            }</div>            
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-calendar"></i></span>${format_date_time(
              row.create_date
            )}</div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-user"></i></span>${
              row.create_user?.username
            }</div>`,
        },
        // {
        //   title: this.$t("status"),
        //   data: (row) => {
        //     const status = row.status;
        //     const statusClass =
        //       status === "completed" ? "is-success" : "is-warning";
        //     const statusText = this.$t(status);
        //     return `<span class="tag ${statusClass}">${statusText}</span>`;
        //   },
        // },
        // {
        //   title: this.$t("created"),
        //   data: (row) => format_date_time(row.create_date),
        // },
        {
          title: this.$t("actions"),
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view request"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  this.view(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view as customer"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  window.open(
                    `/account-request/transference/complete/${row.uuid}`,
                    "_blank"
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: (e) => {
                  this.log(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  this.delete(row);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.request_modal.show_modal();
    },
    edit(row) {
      this.$refs.request_modal.show_modal(row.uuid);
    },
    delete(row) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete transference request?"),
        v,
        () => {
          del("/account-request/transference", { uuid: row.uuid })
            .then(() => {
              v.refresh_datatable();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
    log(row) {
      let v = this;
      v.$refs.log_modal.show(row.uuid);
    },
    view(row) {
      let v = this;
      v.$refs.view_modal.show(row.uuid);
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
